import { createContext } from 'react'

const KanbanBoardContext = createContext()

export default KanbanBoardContext
